import { render, staticRenderFns } from "./modifypassword.vue?vue&type=template&id=71a50052&scoped=true"
import script from "./modifypassword.vue?vue&type=script&lang=js"
export * from "./modifypassword.vue?vue&type=script&lang=js"
import style0 from "./modifypassword.vue?vue&type=style&index=0&id=71a50052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a50052",
  null
  
)

export default component.exports